import { AppUrl } from "./app-url";
import { environment } from "../environments/environment";

export class AppConfig {
  app_host: string = "";
  assine_host: string = "";
  minha_loga_host: string = "";
  host_ms_fatura: string = "";

  private url = new AppUrl();

  constructor() {
    this.app_host = this.url.host;
    this.assine_host = this.url.host_assine;
    this.minha_loga_host = this.url.host_minha_loga;
    this.host_ms_fatura = this.url.host_ms_fatura;

    if (environment.production) {
      this.app_host = "https://admapp.jnnet.com.br";
      this.assine_host = "https://assine.jnnet.com.br";
      this.minha_loga_host = "http://minhajnnet.jnnet.com.br/#";
      this.host_ms_fatura = "https://sgt.loga.net.br/z25f6ab772";
    }
  }
}



// WEBPACK FOOTER //
// /var/www/minha-jnnet/src/app/app-config.ts